import { Cookie } from "./Cookie";

const cookie: Cookie = new Cookie();
const language = cookie.getCookie('language');
let translated: any = '';

if (language) {
    translated = require("../../assets/language/" + language + "/export_translations");
} else {
    translated = require("../../assets/language/spanish/export_translations");
}

export class Language {

    public getCodeLanguage(): string {
        switch (language) {
            case 'english':
                return 'en';
            case 'portuguese-brazilian':
                return 'pt-br';
            default:
                return 'es';
        }
    }

    public getLanguage(): string {
        if (language) {
            return language;
        }
        return 'spanish';
    }

    public getTranslation(key: string): string {
        if (translated.default[key]) {
            return translated.default[key];
        }

        console.log('traducción no encontrada para: ', key);
        return '';
    }
}
